import { create } from 'zustand';
import { ApiUtils, FileApi, type FileEntity, RequestStrategyEnum } from '@shared/api';

interface UseApplicationFilesStore {
  loading: boolean;
  data: FileEntity[];
  error: string | null;
  getApplicationFiles: (applicationId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplicationFilesStore = create<UseApplicationFilesStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getApplicationFiles: ApiUtils.wrapperApi(async (applicationId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await FileApi.getApplicationFiles(applicationId, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
